module.exports = __webpack_public_path__ + "static/media/addFile.6d03e29d.svg";